<template>
	<div style="">
		<div class="midlle">
			<!-- <div class="midller-top">
				<div class="top-item" style="padding-top: 35px;">
					<div class="header">
						<div style="font-size: 18px;font-weight: bold;">
							企业名称
						</div>
						
					</div>
					<p style="margin-top: 20px; font-size: 14px;
							font-family: PingFang;
							font-weight: 400;color: #0052D9;">企业认证用户</p>
					<div class="clounm" style="margin-top: 20px;">
						<div class="title">
							<span class="justi">已成交</span>: <span
								style="font-weight: normal;color: #636363;">10个订单</span>
						</div>
					</div>
					<div class="clounm" style="margin-top: 20px;">
						<div class="title">
							<span class="justi">已发布</span>: <span style="font-weight: normal;color: #636363;">20个项目</span>
						</div>
					</div>

				</div>
				<div class="top-item">
					<div style="margin-top: 10px;">
						<span style="font-weight: bold;">积分：</span> <span
							style="font-weight: normal;color: #636363;">永久3500&ensp;当日50分</span>
					</div>
					<div style="margin-top: 20px;">
						<span style="font-weight: bold;">活跃：</span> <span
							style="font-weight: normal;color: #636363;">无人不识&ensp;(5k-20k)</span>
					</div>
					<div style="margin-top: 20px;">
						<span style="font-weight: bold;">声望：</span> <span
							style="font-weight: normal;color: #636363;">伯乐3级</span>
					</div>
			
					<div style="margin-top: 20px;">
						<span style="font-weight: bold;">贡献：</span> <span
							style="font-weight: normal;color: #636363;">栋梁3级</span>
					</div>
				</div>
			</div> -->
			<div class="swicthBox">
				<div @click="swicth = 1" :class="['swicth-item',swicth == 1 ? 'item-active' : '']">
					积分
				</div>
				<div @click="swicth = 2" :class="['swicth-item',swicth == 2 ? 'item-active' : '']">
					活跃
				</div>
				<div @click="swicth = 3" :class="['swicth-item',swicth == 3 ? 'item-active' : '']">
					声望
				</div>
				<div @click="swicth = 4" :class="['swicth-item',swicth == 4 ? 'item-active' : '']">
					贡献
				</div>

				<div @click="swicth = 6" :class="['swicth-item',swicth == 6 ? 'item-active' : '']">
					评论
				</div>
			</div>
			<div class="table tab1" v-if="swicth == 1">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="score" label="积分数量" width="220">
						<template slot-scope="scope">

							<span style="color: #0052D9;">+{{ scope.row.score }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="way" label="渠道" width="320">
					</el-table-column>
					<el-table-column prop="data" label="时间">
					</el-table-column>
				</el-table>
				<div style="padding: 30px;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</div>
			<div class="table tab1" v-if="swicth == 2">
				<el-table :data="tableData2" style="width: 100%">
					<el-table-column prop="score" label="活跃" width="220">
						<template slot-scope="scope">

							<span style="color: #0052D9;">+{{ scope.row.score }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="way" label="渠道" width="320">
					</el-table-column>
					<el-table-column prop="data" label="时间">
					</el-table-column>
				</el-table>
				<div style="padding: 30px;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</div>
			<div class="table tab1" v-if="swicth == 3">
				<el-table :data="tableData3" style="width: 100%">
					<el-table-column prop="score" label="声望" width="220">
						<template slot-scope="scope">

							<span style="color: #0052D9;">+{{ scope.row.score }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="way" label="渠道" width="320">
					</el-table-column>
					<el-table-column prop="data" label="时间">
					</el-table-column>
				</el-table>
				<div style="padding: 30px;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</div>
			<div class="table tab1" v-if="swicth == 4">
				<el-table :data="tableData4" style="width: 100%">
					<el-table-column prop="score" label="贡献" width="220">
						<template slot-scope="scope">

							<span style="color: #0052D9;">+{{ scope.row.score }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="way" label="渠道" width="320">
					</el-table-column>
					<el-table-column prop="data" label="时间">
					</el-table-column>
				</el-table>
				<div style="padding: 30px;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</div>
			<!-- 		<div style="background: #fff;padding: 30px 40px;" v-if="swicth == 5">
				<div style="margin-bottom: 30px;">
					<div class="beishu-item">
						<div class="dian"></div>
						<div style="margin-left: 10px;">张三研究员在XXX领域走在了世界前列</div>
					</div>
					<p style="margin-left: 15px;color: #888;font-size: 14px;margin-top: 5px;">——XXX院士
					</p>
				</div>
				<div style="margin-bottom:30px;">
					<div class="beishu-item">
						<div class="dian"></div>
						<div style="margin-left: 10px;">张三研究员在XXX领域走在了世界前列</div>
					</div>
					<p style="margin-left: 15px;color: #888;font-size: 14px;margin-top: 5px;">——XXX院士
					</p>
				</div>
			<div style="margin-top: 15px; padding:20px ;display: flex;justify-content: center;">
			 <el-pagination
				   background
				   layout="prev, pager, next"
				 :total="1000">
			 </el-pagination>
			</div>
			</div> -->
			<div class="zhengshu" v-if="swicth == 6">
				<div v-if="false">
					<div class="pinglun" v-for="(item,index) in pinglun">
						<div class="userInfo">
							<div style="width: 70px;height: 70px;border-radius: 50%;overflow: hidden;">
								<img src='../../assets/images/erciyuan.png' style="width: 100%;height: 100%;" alt="">
							</div>
							<p>用户昵称123123</p>
						</div>
						<div class="content">
							<p style="display: flex;color: black;">满意度：<el-rate :value="item.scroe" disabled></el-rate>
							</p>
							<p style="font-size: 14px;margin-top: 10px;">{{item.data}}</p>
							<div :class="'collapse'" :style="item.collapse ?
							'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;text-overflow: ellipsis;'
							:''">
								{{item.content}}
							</div>
							<div v-if="item.content.length > 80" style="float: right;cursor: pointer;margin-top: 8px;"
								@click='item.collapse = !item.collapse'>
								<div v-if="item.collapse">展开 <i class="el-icon-caret-bottom"></i></div>
								<div v-else>收起 <i class="el-icon-caret-top"></i></div>
							</div>
						</div>
					</div>
					<div style="width: 100%; margin-top:auto; padding:20px ;display: flex;justify-content: center;">
						<el-pagination background layout="prev, pager, next" :total="1">
						</el-pagination>
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;width: 100%;" v-else>
					<el-empty :image-size="200" description="暂无消息"></el-empty>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				tableData2: [],
				tableData3: [],
				tableData4: [],
				swicth: 1,
				pinglun: [{
						scroe: 3,
						data: '2023-05-31',
						content: ' 半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、云计算、人工智能等新一代信息技术的出现又为研究发展带来了新的机遇，物理模拟与数据驱动方式融合应用，为气象研究和其他领域的发展带来了无限可能性。',
						collapse: true
					},
					{
						scroe: 3,
						data: '2023-05-31',
						content: ' 半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、云计算、人工智能等新一代信息技术的出现又为研究发展带来了新的机遇，物理模拟与数据驱动方式融合应用，为气象研究和其他领域的发展带来了无限可能性。',
						collapse: true
					}
				]
			}
		}
	}
</script>

<style lang="less" scoped>
	.pinglun {
		.collapse {
			margin-top: 15px;
		}

		color: #909090;
		display: flex;
		align-items: flex-start;
		border-bottom: 1px dashed #eee;
		padding-bottom: 20px;
		margin-bottom: 30px;

		.content {
			margin-left: 28px;
			flex: 1;


			&>p {}
		}

		.userInfo {
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: flex-start;

			p {
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}

	.zhengshu {
		display: flex;
		flex-wrap: wrap;
		padding: 30px 30px;
		background: #fff;

		.img {
			display: flex;
			justify-content: center;
			margin-right: 40px;
			margin-bottom: 30px;
		}
	}

	.dian {
		display: inline-block;
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background: #0052D9;
	}

	.beishu-item {
		display: flex;
		align-items: center;
	}

	.beishu {
		padding: 35px 30px;
		box-sizing: border-box;
	}

	.midlle {


		/deep/.el-table th.el-table__cell.is-leaf {
			border: none;
			background: #FAFAFA;
		}

		/deep/.el-table__cell {
			text-align: left;
			padding-left: 25px;
		}

		/deep/.el-pager li:not(.disabled).active {
			background: #0052D9;
		}

		.table {
			background: #FFFFFF;
		}

		.head-title {
			display: flex;
			padding: 0 30px;
			height: 60px;
			border: 1px solid #EEEEEE;
			border-left: none;
			border-right: none;
			line-height: 60px;
			font-weight: bold;
		}

		.swicthBox {
			font-size: 18px;
			margin-top: 20px;
			height: 70px;
			line-height: 70px;
			display: flex;
			background: #FFFFFF;

			.swicth-item {
				cursor: pointer;
				margin: 0 35px;
				text-align: center;
			}

			.item-active {
				color: #0052D9;
				font-weight: 550;
				border-bottom: 5px solid #0052D9;
			}
		}

		width: 860px;
		padding: 0 20px;
		box-sizing: border-box;

		.midller-top {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.top-item {
				.clounm {
					margin-top: 15px;
					display: flex;

					.title {
						font-weight: bold;

						.justi {
							display: inline-block;
							text-align-last: justify;
							text-align: justify;
							width: 65px;
						}
					}
				}

				font-size: 16px;

				.header {
					display: flex;
					justify-content: space-between;
				}

				padding: 20px 0 20px 20px;
				box-sizing: border-box;
				width: 400px;
				height: 205px;
				background: #FFFFFF;
			}
		}
	}
</style>